module.exports = __webpack_public_path__ + "img/double-check.10af45a5.svg";